import { LitElement, html, css } from '@hh/global.js'

class HHInputWrapper extends LitElement {
  static properties = {
    animation: {},
    focused: {
      reflect: true,
    },
    filled: {
      reflect: true,
    },
    type: {
      type: String,
      reflect: true,
    },
    label: {},
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.$select = this.querySelector(`select[slot='input']`)
    this.$select && this.preselectSelectValue()
    if (!!this.querySelector(`[slot='input']`).value && !this.$select) {
      this.filled = true
    }

    if (this.$select && this.label !== 'stacked') {
      this.filled = true
    }
  }

  preselectSelectValue() {
    if (this.$select?.dataset?.default) {
      this.$select.value = this.$select?.dataset?.default
    }
  }

  onChange(e) {
    if (this.animation === 'none' || this.label === 'stacked') {
      return
    }
    this.filled = !!e.target.value
  }

  onFocus(e) {
    if (this.animation === 'none') {
      return
    }
    this.focused = true
  }

  onFocusOut(e) {
    if (this.animation === 'none') {
      return
    }
    this.focused = false
  }

  render() {
    return html`
      <slot name="label"></slot>
      <slot name="icon"></slot>
      <slot
        name="input"
        @change="${this.onChange}"
        @keydown="${this.onChange}"
        @focusin="${this.onFocus}"
        @focusout="${this.onFocusOut}"
      ></slot>
    `
  }

  static styles = css`
    ::slotted(label) {
      color: var(--hh-color-ancient-ore);
      font: var(--hh-body-font);
      letter-spacing: -0.42px;
      height: max(2.3vh, 2rem);
      top: 1.5rem;
      transform: translateY(0);
      transition:
        transform var(--hh-duration-default, 300ms),
        font-size var(--hh-duration-default, 300ms);
    }

    ::slotted(label),
    ::slotted(input),
    ::slotted(textarea) {
      width: 100%;
      position: absolute;
    }

    ::slotted(select:-webkit-autofill),
    ::slotted(input:-webkit-autofill),
    ::slotted(textarea:-webkit-autofill) {
      -webkit-text-fill-color: var(--hh-color-aged-black, #000) !important;
      background: transparent !important;
      -webkit-box-shadow: unset !important;
    }

    ::slotted(input),
    ::slotted(textarea) {
      border: 0;
      font: var(--hh-body-font);
      letter-spacing: -0.42px;
      color: var(--hh-color-aged-black, #000);
      background: transparent;
      padding: 0;
      height: max(2.3vh, 2rem);
      bottom: 0;
      border-bottom: 1px solid var(--hh-color-aged-black, #000);
      outline: none !important;
      padding-top: 1.5rem;
      padding-bottom: 0.65rem;
      border-radius: 0;
    }

    ::slotted(input:-internal-autofill-selected) {
      appearance: none;
      box-shadow: var(--hh-color-sundrenched-stone) 0px 0px 0px 1000px inset !important;
      -webkit-box-shadow: 0 0 0 1000px var(--hh-color-sundrenched-stone) inset !important;
    }

    ::slotted(textarea) {
      height: 6rem;
    }

    :host([focused='true']) ::slotted(label),
    :host([filled='true']) ::slotted(label) {
      font: var(--hh-body-caption);
      letter-spacing: -0.36px;
      transform: translateY(-3px);
      height: max(2rem, 1.7rem);
      top: 0.65rem;
    }

    :host {
      position: relative;
      display: block;
      height: 5rem;
      background: transparent;
    }

    :host([type='textarea']) {
      height: 9rem;
    }
  `
}

customElements.define('hh-input-wrapper', HHInputWrapper)
